import { render } from "./StudentRegistrationReport.vue?vue&type=template&id=1cf5800c&scoped=true"
import script from "./StudentRegistrationReport.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationReport.vue?vue&type=script&lang=js"

import "./StudentRegistrationReport.vue?vue&type=style&index=0&id=1cf5800c&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf5800c"]])

export default __exports__